import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

import UserSignInModal from '@/vcs/_shared/modals/UserSignInModal.vue'
import { eventBus } from '@/vcs/_shared/eventBus'
import UserSearch from './user-search/cmp.vue'
import UserSignIn from './user-sign-in/cmp.vue'

export default {
  name: 'SenderInfo',
  components: { vSelect, UserSearch, UserSignIn },
  data: function () {
    return {
      companyName: '',
      user: null,
      isUserSignedIn: false
    }
  },
  watch: {
    companyName: function (newCompanyName) {
      this.$emit('company-name-changed', newCompanyName)
      eventBus.$emit('refresh-token-via-websockets')
    }
  },
  mounted() {
    this.handleClientUserIfExists()
    if (this.isUSP) this.companyName = 'Recepcja Wytwórnia USP'
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    }),
    displayUserSearch() {
      return this.cp.allowUserSearch && this.cp.qrEnabled && !this.isUSP
    },
    isUSP() {
      return this.$store.getters.getServiceProviderSlug == 'usp'
    }
  },
  methods: {
    handleClientUserIfExists() {
      let clientUser = JSON.parse(window.localStorage.getItem('client_user'))
      if (clientUser) {
        this.handleSignedInUser(clientUser)
      }
    },
    createCompanyNameBasedOnUser(user = {}) {
      let { name, phone, email, phonePrefix } = user || {}
      let companyName

      if (name && phone && email) {
        companyName = `${name} (+${phonePrefix || '48'} ${phone} | ${email})`
      } else if (phone && email) {
        companyName = `+${phonePrefix || '48'} ${phone} | ${email}`
      } else if (name && email) {
        companyName = `${name} (${email})`
      } else if (email) {
        companyName = email
      } else {
        companyName = ''
      }
      return companyName
    },

    // searched user
    userFoundHandler(user) {
      this.$emit('user-changed', user)
      this.$emit('company-name-changed', this.createCompanyNameBasedOnUser(user))
    },
    companyNameChangedHandler(string) {
      this.$emit('company-name-changed', string)
    },

    // signed in user
    openSignInModal() {
      this.$store.commit('modal/open', {
        cmp: UserSignInModal,
        callback: this.handleSignedInUser
      })
    },
    handleSignedInUser(user) {
      this.isUserSignedIn = true
      this.user = user
      this.$emit('user-changed', user)
      this.$emit('company-name-changed', this.createCompanyNameBasedOnUser(user))
      this.companyName = this.createCompanyNameBasedOnUser(user)
      eventBus.$emit('refresh-token-via-websockets')
    },
    signOut() {
      this.isUserSignedIn = false
      this.user = null
      this.$emit('company-name-changed', '')
      this.$emit('user-changed', null)
    }
  }
}
